import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonUse", "hasSearchbox", "isDisplayOptimized", "placement", "aria-invalid", "dropdownStyles"];
import { Component } from 'react';
import { AbstractDropdown } from './AbstractDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
export class AbstractDropdownWithSearchbox extends Component {
  static getDerivedStateFromProps(props, state) {
    let derivedState = {};
    if (props.placement !== state.prevPlacement) {
      derivedState = Object.assign({}, derivedState, {
        placement: null,
        prevPlacement: props.placement
      });
    }
    if (props.open && !state.prevOpen) {
      derivedState = Object.assign({}, derivedState, {
        placement: null,
        prevOpen: props.open
      });
    } else if (props.open !== state.prevOpen) {
      derivedState = Object.assign({}, derivedState, {
        prevOpen: props.open
      });
    }
    return derivedState;
  }
  constructor(props) {
    var _props$open;
    super(props);
    this.handleChangePlacement = evt => {
      const {
        onChangePlacement
      } = this.props;
      const {
        newPlacement
      } = evt;
      if (this.state.placement !== newPlacement) {
        this.setState({
          placement: newPlacement
        });
      }
      if (onChangePlacement) onChangePlacement(evt);
    };
    this.state = {
      placement: null,
      prevPlacement: props.placement,
      prevOpen: (_props$open = props === null || props === void 0 ? void 0 : props.open) !== null && _props$open !== void 0 ? _props$open : false
    };
  }
  render() {
    const _this$props = this.props,
      {
        buttonUse,
        hasSearchbox,
        isDisplayOptimized,
        placement = 'bottom right',
        'aria-invalid': ariaInvalid,
        dropdownStyles
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      placement: placementState
    } = this.state;
    const defaultPlacement = buttonUse !== null && buttonUse !== void 0 && buttonUse.match(/link|transparent/) ? 'bottom' : 'bottom right';
    const computedPlacement = placementState || placement || defaultPlacement;
    const computedArrowColor = hasSearchbox ? 'temp-future-fill-surface-recessed' : undefined;
    return /*#__PURE__*/_jsx(AbstractDropdown, Object.assign({}, rest, {
      arrowColor: computedArrowColor,
      "aria-invalid": ariaInvalid,
      buttonUse: buttonUse,
      isDisplayOptimized: isDisplayOptimized,
      onChangePlacement: this.handleChangePlacement,
      placement: computedPlacement,
      autoPlacement: true,
      dropdownStyles: dropdownStyles
    }));
  }
}